import { css } from '@inter-ikea-kompis/web-component';

import { Text } from '@ingka/common-styles-webc';
import * as colors from '@ingka/variables/colours-css';
import * as tokens from '@ingka/variables/design-tokens';

export default class ProductCardTakeBackReturnInformationQrCardStyle {
	public static getStyle(): string {
		return css`
			${Text.CSS}

			.qr-code-container {
				display: flex;
				flex-direction: column;
				padding: ${tokens.space250};
				border-radius: ${tokens.radiusM};
				background-color: ${colors.colourNeutral2};
			}

			.qr-code-background {
				padding: ${tokens.space125};
				margin: 0 auto;
				border-radius: ${tokens.radiusS};
				background-color: ${colors.colourStaticWhite};
			}

			kompis-qr-code {
				display: block;
				max-width: ${208 / 16}rem;
			}

			.qr-code-text {
				margin-top: ${tokens.space250};
				margin-bottom: 0;
				text-align: center;
			}
		`;
	}
}
